import styled, { keyframes, css } from 'styled-components';

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Text = styled.span`
  font-size: 16px;
  line-height: 25px;
  color: ${p => p.theme.colors.white};
  display: inline-block;
  opacity: ${props => (props.$loading || props.$returning) ? 0 : 1};
  transition: 
    opacity 0.4s cubic-bezier(0.34, 1.56, 0.64, 1),
    transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  transition-delay: ${props => props.$returning ? '0.55s' : '0s'};
  white-space: nowrap;
`;

export const ButtonContainer = styled.button`
  flex-grow: 0 !important;
  position: relative;
  width: ${props => (props.$loading || props.$returning) ? '50px' : '210px'} !important;
  height: 50px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #6439D0 !important;
  border-radius: ${props => (props.$loading || props.$returning) ? '50%' : '3.125em'};
  padding: ${props => (props.$loading || props.$returning) ? '0' : '12px 24px'} !important;
  border: none;
  overflow: hidden;
  margin-right: 0 !important;
  
  ${props => !props.$ismobile && css`
    align-self: flex-start;
    margin-left: 0;
    transition: 
      opacity 0.4s cubic-bezier(0.215, 0.61, 0.355, 1),
      transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1),
      width 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${props => props.$returning ? '0.15s' : '0s'},
      border-radius 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${props => props.$returning ? '0.15s' : '0s'},
      padding 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${props => props.$returning ? '0.15s' : '0s'};
  `}
  
  ${props => props.$ismobile && css`
    align-self: center;
    margin: 0 auto;
    transition: 
      opacity 0.4s cubic-bezier(0.215, 0.61, 0.355, 1),
      transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1),
      width 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${props => props.$returning ? '0.15s' : '0s'},
      border-radius 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${props => props.$returning ? '0.15s' : '0s'},
      padding 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${props => props.$returning ? '0.15s' : '0s'},
      margin 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${props => props.$returning ? '0.15s' : '0s'};
  `}

  @media (max-width: 768px) {
    width: ${props => (props.$loading || props.$returning) ? '50px' : '100%'} !important;   
    ${props => props.$ismobile && css`
      margin: 0 auto !important;
    `}
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.07);
    border-radius: inherit;
    opacity: 0;
    transform: scale(1.1);
    transition: 
      opacity 0.4s cubic-bezier(0.215, 0.61, 0.355, 1),
      transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    z-index: 1;
  }

  > * {
    z-index: 3;
    position: relative;
    transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  
  &:hover:not(:disabled):not(.button--loading):not(.button--returning) {
    cursor: pointer;
    transform: scale(1.1) translateZ(0);
    
    &::before {
      opacity: 1;
    }
    ${Text} {
      transform: scale(0.909);
    }
  }

  &:active:not(:disabled):not(.button--loading):not(.button--returning)::before {
    opacity: 0.15;
    transform: scale(0.95);
  }
  
  &:focus {
    outline: none;
  }
`;

export const bounceIn = keyframes`
  0% { transform: translate(-50%, -50%) scale(0); opacity: 0; }
  70% { transform: translate(-50%, -50%) scale(1.1); opacity: 1; }
  100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
`;

export const bounceOut = keyframes`
  0% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
  30% { transform: translate(-50%, -50%) scale(1.1); opacity: 0.8; }
  100% { transform: translate(-50%, -50%) scale(0); opacity: 0; }
`;

export const Loader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  
  animation: ${props => {
    if (props.$loading) return css`${bounceIn} 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards`;
    if (props.$returning) return css`${bounceOut} 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards`;
    return 'none';
  }};
  
  opacity: ${props => {
    if (props.$loading) return 1;
    if (props.$returning) return 1;
    return 0;
  }};
  
  visibility: ${props => {
    if (props.$loading || props.$returning) return 'visible';
    return 'hidden';
  }};
  
  &::after {
    content: '';
    display: block;
    width: 20px;
    height: 20px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top: 2px solid white;
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
  }
`;